
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import IconButton from 'Common/Components/IconButton';
import { Trash } from 'Screens/Contextualization/Manage/components/CustomActionBar/styled';
import ModalWarning from 'Common/Components/ModalWarning';
import { selectReadOnly } from 'store/Faraday/selectors';

const DeleteHostButton = ({ hasHosts, showHostModalDelete, hostsSelected, showHostDetail }) => {
  const readOnly = useSelector(selectReadOnly);
  const [showWarning, setShowWarning] = useState(false);
  const canUpdate = !readOnly && !showHostDetail && hasHosts;
  const intl = useIntl();
  const message = intl.formatMessage({ id: 'modalWarning.selectOneOrMore' }, { entity: 'assets' });

  const handleClick = () => {
    if (canUpdate) {
      if (hostsSelected.length > 0) showHostModalDelete();
      else setShowWarning(true);
    }
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <IconButton icon={ <Trash /> } title="Delete" onClick={ handleClick } disabled={ readOnly || showHostDetail || !hasHosts } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title="Delete" description={ message } /> }
    </>
  );
};

export default DeleteHostButton;
